import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../../store/authStore';
import toast from 'react-hot-toast';
import './Login.css';

export default function Login() {
  const navigate = useNavigate();
  const { login, requires2fa, tempUsername, tempPassword } = useAuthStore();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [otp, setOtp] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault(); setLoading(true);
    try {
      await login(requires2fa ? tempUsername : username, requires2fa ? tempPassword : password, requires2fa ? otp : undefined);
      navigate('/');
    } catch (err: any) {
      toast.error(err.response?.data?.error || 'Xəta baş verdi');
    } finally { setLoading(false); }
  };

  return (
    <div className="lg-root">
      <div className="lg-bg"><div className="lg-scan"/><div className="lg-grid"/></div>
      <div className="lg-card">
        <div className="lg-logo">
          <div className="lg-icon"><svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 14.5v-9l6 4.5-6 4.5z"/></svg></div>
          <span>KAMERA</span>
        </div>
        <div className="lg-subtitle">{requires2fa ? '2FA KOD DAXİL EDİN' : 'SİSTEMƏ GİRİŞ'}</div>
        <form onSubmit={handleSubmit} className="lg-form">
          {!requires2fa ? (<>
            <div className="lg-field"><label>İSTİFADƏÇİ ADI</label><input type="text" value={username} onChange={e => setUsername(e.target.value)} autoComplete="username" required /></div>
            <div className="lg-field"><label>ŞİFRƏ</label><input type="password" value={password} onChange={e => setPassword(e.target.value)} autoComplete="current-password" required /></div>
          </>) : (
            <div className="lg-field">
              <label>AUTHENTICATOR KODU</label>
              <input type="text" value={otp} onChange={e => setOtp(e.target.value.replace(/\D/g,'').slice(0,6))} placeholder="000000" maxLength={6} autoFocus required className="otp-inp" />
            </div>
          )}
          <button type="submit" className="lg-btn" disabled={loading}>
            {loading ? <span className="lg-spin"/> : requires2fa ? 'TƏSDİQLƏ' : 'GİRİŞ'}
          </button>
        </form>
        <div className="lg-foot"><span>⇌ SSL şifrəli bağlantı</span></div>
      </div>
    </div>
  );
}
